import React from 'react';
import { useBrand } from '../../../app/config/brand';

interface CasesPaginationProps {
  page: number;
  perPage: number;
  total: number;
  onPageChange: (page: number) => void;
}

export const CasesPagination: React.FC<CasesPaginationProps> = ({
  page,
  perPage,
  total,
  onPageChange,
}) => {
  const brand = useBrand();
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const start = Math.min((page - 1) * perPage + 1, total);
  const end = Math.min(page * perPage, total);

  if (total === 0) return null;

  return (
    <div
      className="flex items-center justify-between mt-6 pt-4"
      style={{ borderTop: `1px solid ${brand.colors.border}` }}
      data-testid="cases-pagination"
    >
      <span className="text-sm" style={{ color: brand.colors.textLight }}>
        Showing {start}-{end} of {total}
      </span>
      <div className="flex items-center gap-3">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="px-3 py-1.5 rounded-lg text-sm font-medium transition-colors disabled:opacity-40"
          style={{
            backgroundColor: brand.colors.bgLight,
            color: brand.colors.text,
          }}
          data-testid="pagination-prev"
        >
          Previous
        </button>
        <span className="text-sm" style={{ color: brand.colors.textLight }}>
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="px-3 py-1.5 rounded-lg text-sm font-medium transition-colors disabled:opacity-40"
          style={{
            backgroundColor: brand.colors.bgLight,
            color: brand.colors.text,
          }}
          data-testid="pagination-next"
        >
          Next
        </button>
      </div>
    </div>
  );
};
